module.exports = __webpack_public_path__ + "img/match--type2_img6.bb591bdf.png";